import { HOSPITAL_PATIENT } from '../../../routes/urls';

export interface OpenVisitLinkInput {
    patientInvestigationUuid: string;
    visitUuid: string;
}

/**
 * SKIN-699 — every open-visits row links to the clinical history with the visit
 * expanded, where its status is changed (Close/Void, SKIN-696). Unlike the shared
 * buildVisitWithoutImagesLink, this never routes to the submission viewer: a visit
 * that carries a submission must still land on the status controls, not on a
 * read-only submission page. Deep-linking to the visit is handled by the clinical
 * history via ?visitUuid (SKIN-55).
 */
export function buildOpenVisitLink(row: OpenVisitLinkInput): string {
    const patientUrl = HOSPITAL_PATIENT.replace(':uuidPatient', row.patientInvestigationUuid);
    return `${patientUrl}?visitUuid=${encodeURIComponent(row.visitUuid)}`;
}
